export default "__VITE_ASSET__ryKg_7Yp__"